export const UNIT = 'Unit';
//# sourceMappingURL=unit.js.map